import { t } from 'i18next';
import * as yup from 'yup';

export const addJobSchema = (hasProjectField: boolean) =>
  yup.object().shape({
    ...(hasProjectField && {
      project: yup.object().label(t('labelProject')).nullable().required(),
    }),
    jobName: yup.string().label(t('labelJobName')).nullable().required(),
    discipline: yup.object().label(t('labelDiscipline')).nullable(),
  });
